import React, { ReactNode } from 'react';
import { ColorValue, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import useCustomTheme from '../../../hooks/theme-hook';
import Label, { LabelType } from '../Label';

interface MissionCompensationRowProps {
  icon: React.ComponentProps<typeof FontAwesomeIcon>['icon'];
  heading: string;
  caption?: string;
  large?: boolean;
  separator?: boolean;
  underlineCaption?: boolean;
  color?: ColorValue;
  iconColor?: ColorValue;
  help?: ReactNode;
  children?: ReactNode;
}

const MissionCompensationRow = ({ icon, heading, caption, large = false, separator = false,
  underlineCaption = false, color, iconColor, help, children }: MissionCompensationRowProps) => {
  const theme = useCustomTheme();
  const textColor = color ?? theme.text.titleDark;
  const separatorColor = theme.isDark ? theme.borderColorLight : theme.background.primary;

  return <View testID="mission-compensation-row" style={{
    marginHorizontal: 12, paddingVertical: 12, minWidth: 0, flexDirection: 'row', alignItems: 'flex-start',
    borderTopWidth: separator ? 1 : 0, borderTopColor: separatorColor,
  }}>
    <FontAwesomeIcon icon={icon} color={(iconColor ?? textColor).toString()} size={20}
      style={{ width: 20, flexShrink: 0, marginTop: large ? 6 : 1 }} />
    <View style={{ marginLeft: 10, flex: 1, minWidth: 0 }}>
      <Label numberOfLines={0} variant={large ? LabelType.valueLargeMission : LabelType.titleDarkSmall}
        style={{ color: textColor, fontSize: large ? 26 : 16, lineHeight: large ? 32 : 22,
          fontWeight: '700', minWidth: 0, textAlign: 'left' }}>
        {heading}
      </Label>
      {!!caption && <Label numberOfLines={0} variant={LabelType.titleDarkSmall}
        style={{ color: textColor, fontSize: 14, lineHeight: 20, fontWeight: '400', marginTop: 2,
          minWidth: 0, textAlign: 'left', ...(underlineCaption ? { textDecorationLine: 'underline' as const } : {}) }}>
        {caption}
      </Label>}
      {children}
    </View>
    {!!help && <View style={{ marginLeft: 6, flexShrink: 0 }}>{help}</View>}
  </View>;
};

export default MissionCompensationRow;
